import { render, staticRenderFns } from "./ArchiveDialog.vue?vue&type=template&id=0a5eee72"
import script from "./ArchiveDialog.vue?vue&type=script&lang=ts"
export * from "./ArchiveDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports